import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';
interface AnnouncerValue {
  /** Announce a change politely through the one shared region. */
  announce: (message: string) => void;
}
const AnnouncerContext = createContext<AnnouncerValue>({
  announce: () => {}
});

/**
 * One shared polite live region for every dynamic announcement on the page:
 * revealed prices, carousel position, form results. Several competing
 * regions interrupt each other, so there is deliberately only this one.
 */
export function LiveRegionProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [message, setMessage] = useState('');
  const timeout = useRef<number | undefined>(undefined);
  const announce = useCallback((next: string) => {
    window.clearTimeout(timeout.current);
    // Clear first so repeating the same string is still announced.
    setMessage('');
    timeout.current = window.setTimeout(() => setMessage(next), 60);
  }, []);
  const value = useMemo(() => ({
    announce
  }), [announce]);
  return <AnnouncerContext.Provider value={value} data-id="element-443" data-mp="166tyc5qxwuau">
      {children}
      <div data-component-id="C08" role="status" aria-live="polite" aria-atomic="true" className="sr-only" data-id="element-444" data-mp="115ef8j8boxv3">
        {message}
      </div>
    </AnnouncerContext.Provider>;
}
export function useAnnouncer(): AnnouncerValue {
  return useContext(AnnouncerContext);
}